import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=c6b52cec"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports